export enum BoardActions {
  loadBoard = 'LOAD_BOARD',
  addList = 'ADD_LIST',
  changeLists = 'UPDATE_LISTS',
  setCard = 'SET_CURRENT_CARD',
  setDragCard = 'SET_DRAG_CARD',
  setSlotPosition = 'SET_SLOT_POSITION',
  clearBoard = 'CLEAR_BOARD',
  setDragging = 'SET_DRAGGING',
}

export enum HomeActions {
  updateBoards = 'UPDATE_BOARDS',
}
